import { ProjectType } from '../../../../../types/project';
import { FileFormat, PlaceholderFormat, PluralFormat } from '../../../types';

export const isJavaPropertiesSeparatorInputVisible = (fileFormat: FileFormat) =>
    fileFormat === FileFormat.javaProperties;

export const isJavaPropertiesEncodingInputVisible = (fileFormat: FileFormat) =>
    fileFormat === FileFormat.javaProperties;

export const isSwitchIcuNumericInputVisible = (pluralFormat: PluralFormat) => pluralFormat === PluralFormat.icu;

const showSwitchEscapePercentInputWhiteList = [PlaceholderFormat.ios, PlaceholderFormat.printf];
export const isSwitchEscapePercentInputVisible = (placeholderFormat: PlaceholderFormat) =>
    showSwitchEscapePercentInputWhiteList.includes(placeholderFormat);

export const isOptionsVisible = (projectType: ProjectType) => projectType === ProjectType.localizationFiles;

export const isExportSortInputVisible = (fileFormat: FileFormat, projectType: ProjectType) =>
    fileFormat !== FileFormat.srt && projectType === ProjectType.localizationFiles;

const showPlaceholderFormatInputBlacklist = [
    FileFormat.androidSdk,
    FileFormat.resx,
    FileFormat.arb,
    FileFormat.flutterSdk,
];
export const isPlaceholderFormatInputVisible = (fileFormat: FileFormat) =>
    !showPlaceholderFormatInputBlacklist.includes(fileFormat);

export const isPluralFormatInputVisible = (fileFormat: FileFormat) => fileFormat !== FileFormat.flutterSdk;

export const isExportEmptyInputVisible = (fileFormat: FileFormat) => fileFormat !== FileFormat.flutterSdk;

export const isExportAsNullVisible = (fileFormat: FileFormat) => fileFormat === FileFormat.yamlRuby;
